export default __webpack_public_path__ + "static/media/Ma009-6.5d42553f.svg";